import { Type, Transform } from 'class-transformer';
import {
  IsInt,
  IsNumber,
  IsIn,
  IsArray,
  IsString,
  IsDateString,
  IsUUID,
  IsNotEmpty,
  ValidateNested,
  IsOptional,
  IsBoolean,
} from 'class-validator';
import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import {
  FiltersResponse,
  Filter,
  FilterService,
  FilterType,
} from '@vk-hr-tek/core/filter';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { QueryService } from '@vk-hr-tek/core/query';

export class ResetWidgetContentParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class WidgetLinkLogoParams {
  @IsUUID()
  @IsNotEmpty()
  link_id: string;
}

export class GetWidgetBannerImageFileParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;

  @IsUUID()
  @IsNotEmpty()
  image_file_id: string;
}

export class DeleteCompanyWidgetsExceptionsFromAccountParams {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;
}

export class GetAccountWidgetParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateWidgetBirthdaysParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetBirthdaysParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetPostsFeedCategoriesFilterOptionParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetWidgetPostsFeedCommunitiesFilterOptionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetPostsFeedAvailableFiltersParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateAccountWidgetPostsFeedParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetPostsFeedParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateWidgetAbsencesParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetAbsencesParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetPartitionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateWidgetPartitionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetCreateOptionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class DeleteWidgetBannerParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateWidgetBannerParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetBannerParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateWidgetTopNewsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetTopNewsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateAccountWidgetLinksParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetLinksParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateAccountWidgetQuickActionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetAccountWidgetQuickActionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class CreateWidgetBannerParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}

export class GetAccountWidgetsExceptionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}

export class UpdateAccountWidgetMainLayoutParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}

export class GetAccountWidgetMainLayoutParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}

export class GetUserWidgetExternalParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetCalendarParams {
  @IsInt()
  @IsNotEmpty()
  year: number;
}

export class GetUserWidgetPostsFeedParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetBirthdaysParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetTopNewsParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetBannerParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetPartitionsParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class UpdateUserWidgetActiveStateParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetSurveysParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetNewsParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetPersonalLinksParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetUserWidgetQuickActionsParams {
  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetWidgetListAvailableFiltersQuery {
  @IsIn(['account', 'company'])
  @IsString()
  @IsNotEmpty()
  bind_type: 'account' | 'company';
}

export class GetWidgetSurveysQuery {
  @IsInt()
  @IsOptional()
  limit?: number;
}

export class UpdateWidgetBirthdaysQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetBirthdaysQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetPostsFeedCategoriesFilterOptionQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsIn(['posts', 'news'])
  @IsString()
  @IsOptional()
  type?: 'posts' | 'news';
}

export class GetWidgetPostsFeedCommunitiesFilterOptionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  ids?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetAccountWidgetPostsFeedAvailableFiltersQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsIn(['posts', 'news'])
  @IsString()
  @IsOptional()
  type?: 'posts' | 'news';
}

export class UpdateAccountWidgetPostsFeedQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetPostsFeedQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsIn(['posts', 'news'])
  @IsString()
  @IsNotEmpty()
  type: 'posts' | 'news';

  @IsString()
  @IsOptional()
  title_search?: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  category_ids?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  author_ids?: string[];

  @IsIn(['all', 'important'])
  @IsString()
  @IsOptional()
  is_important?: 'all' | 'important';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  community_ids?: string[];

  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class UpdateWidgetAbsencesQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetAbsencesQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetPartitionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class UpdateWidgetPartitionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class DeleteWidgetBannerQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class UpdateWidgetBannerQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetBannerQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class UpdateWidgetTopNewsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetTopNewsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class UpdateAccountWidgetLinksQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetLinksQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class UpdateAccountWidgetQuickActionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetQuickActionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class CreateWidgetBannerQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetsExceptionsQuery {
  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class UpdateAccountWidgetMainLayoutQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetAccountWidgetMainLayoutQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class GetUserWidgetPostsFeedQuery {
  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class GetUserWidgetQuickActionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;
}

export class FilterTimeRange {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['timerange'])
  @IsString()
  @IsNotEmpty()
  type: 'timerange';

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsIn(['till_now', 'any', 'from_now'])
  @IsString()
  @IsNotEmpty()
  allow_dates: 'till_now' | 'any' | 'from_now';

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterBool {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['bool'])
  @IsString()
  @IsNotEmpty()
  type: 'bool';

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;

  @IsString()
  @IsOptional()
  tooltip?: string;
}

export class FilterMultipleSearch {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['multiple-search'])
  @IsString()
  @IsNotEmpty()
  type: 'multiple-search';

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterSearch {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['search'])
  @IsString()
  @IsNotEmpty()
  type: 'search';

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterText {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['text'])
  @IsString()
  @IsNotEmpty()
  type: 'text';

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterSelectBadge {
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsIn(['blue', 'velvet', 'red'])
  @IsString()
  @IsOptional()
  color?: 'blue' | 'velvet' | 'red';

  @IsIn(['left', 'bottom'])
  @IsString()
  @IsOptional()
  position?: 'left' | 'bottom';
}

export class FilterSelectOption {
  @IsString()
  @IsNotEmpty()
  value: string;

  @IsString()
  @IsNotEmpty()
  label: string;

  @IsIn(['item'])
  @IsString()
  @IsOptional()
  type?: 'item';

  @ValidateNested()
  @Type(() => FilterSelectBadge)
  @IsOptional()
  badge?: FilterSelectBadge;
}

export class FilterMultiple {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['multiple'])
  @IsString()
  @IsNotEmpty()
  type: 'multiple';

  @ValidateNested({ each: true })
  @Type(() => FilterSelectOption)
  @IsArray()
  @IsNotEmpty()
  options: FilterSelectOption[];

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;

  @IsBoolean()
  @IsOptional()
  autocomplete?: boolean;

  @IsBoolean()
  @IsOptional()
  clearable?: boolean;
}

export class FilterSelect {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['select'])
  @IsString()
  @IsNotEmpty()
  type: 'select';

  @ValidateNested({ each: true })
  @Type(() => FilterSelectOption)
  @IsArray()
  @IsNotEmpty()
  options: FilterSelectOption[];

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  autocomplete?: boolean;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class AvailableFilters {
  @IsArray()
  @IsNotEmpty()
  filters: (
    | FilterSelect
    | FilterMultiple
    | FilterText
    | FilterSearch
    | FilterMultipleSearch
    | FilterBool
    | FilterTimeRange
  )[];
}

export class WidgetAccount {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class WidgetCompany {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class WidgetSettings {
  @IsBoolean()
  @IsNotEmpty()
  user_editable: boolean;

  @IsBoolean()
  @IsNotEmpty()
  user_switchable: boolean;

  @IsBoolean()
  @IsOptional()
  has_filter?: boolean;

  @IsBoolean()
  @IsOptional()
  is_content_filled?: boolean;
}

export class WidgetPosition {
  @IsInt()
  @IsNotEmpty()
  x: number;

  @IsInt()
  @IsNotEmpty()
  y: number;
}

export type WidgetType = string;

export class Widget {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsIn([
    'quick_actions',
    'tasks',
    'links',
    'calendar',
    'partitions_employee',
    'partitions_company',
    'personal_links',
    'banner',
    'external',
    'news',
    'surveys',
    'absences',
    'top_news',
    'posts_feed',
    'birthdays',
  ])
  @IsString()
  @IsNotEmpty()
  type:
    | 'quick_actions'
    | 'tasks'
    | 'links'
    | 'calendar'
    | 'partitions_employee'
    | 'partitions_company'
    | 'personal_links'
    | 'banner'
    | 'external'
    | 'news'
    | 'surveys'
    | 'absences'
    | 'top_news'
    | 'posts_feed'
    | 'birthdays';

  @IsString()
  @IsOptional()
  custom_name?: string;

  @IsString()
  @IsNotEmpty()
  description: string;

  @IsBoolean()
  @IsNotEmpty()
  is_active: boolean;

  @IsUUID()
  @IsNotEmpty()
  content_id: string;

  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsUUID()
  @IsOptional()
  company_id?: string;

  @ValidateNested()
  @Type(() => WidgetPosition)
  @IsNotEmpty()
  position: WidgetPosition;

  @IsIn([1, 2, 3])
  @IsInt()
  @IsNotEmpty()
  size: 1 | 2 | 3;

  @ValidateNested()
  @Type(() => WidgetSettings)
  @IsNotEmpty()
  settings: WidgetSettings;
}

export class GetSocialWidgetListResponse {
  @ValidateNested({ each: true })
  @Type(() => Widget)
  @IsArray()
  @IsNotEmpty()
  widgets: Widget[];

  @IsInt()
  @IsNotEmpty()
  widgets_total: number;

  @ValidateNested({ each: true })
  @Type(() => WidgetCompany)
  @IsArray()
  @IsNotEmpty()
  companies: WidgetCompany[];

  @ValidateNested({ each: true })
  @Type(() => WidgetAccount)
  @IsArray()
  @IsNotEmpty()
  accounts: WidgetAccount[];
}

export class WidgetAccessTokenResponse {
  @IsString()
  @IsOptional()
  widget_access_token?: string;

  @IsInt()
  @IsOptional()
  expires_at?: number;
}

export class WidgetSurveyItemCategory {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['gray', 'darkgray', 'green', 'orange', 'purple', 'blue', 'red'])
  @IsString()
  @IsNotEmpty()
  color: 'gray' | 'darkgray' | 'green' | 'orange' | 'purple' | 'blue' | 'red';
}

export class WidgetSurveyItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @ValidateNested()
  @Type(() => WidgetSurveyItemCategory)
  @IsNotEmpty()
  category: WidgetSurveyItemCategory;

  @IsBoolean()
  @IsNotEmpty()
  is_anonymous: boolean;

  @IsBoolean()
  @IsOptional()
  show_results?: boolean;

  @IsDateString()
  @IsOptional()
  completed_at?: string;

  @IsUUID()
  @IsNotEmpty()
  cover_att_id: string;
}

export class GetWidgetSurveysResponse {
  @ValidateNested({ each: true })
  @Type(() => WidgetSurveyItem)
  @IsArray()
  @IsNotEmpty()
  surveys: WidgetSurveyItem[];
}

export class WidgetNewsItemCategory {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['gray', 'darkgray', 'green', 'orange', 'purple', 'blue', 'red'])
  @IsString()
  @IsNotEmpty()
  color: 'gray' | 'darkgray' | 'green' | 'orange' | 'purple' | 'blue' | 'red';
}

export class WidgetNewsItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @ValidateNested()
  @Type(() => WidgetNewsItemCategory)
  @IsOptional()
  category?: WidgetNewsItemCategory;
}

export class GetWidgetNewsResponse {
  @ValidateNested({ each: true })
  @Type(() => WidgetNewsItem)
  @IsArray()
  @IsNotEmpty()
  news: WidgetNewsItem[];
}

export type WidgetBirthdaysManagersLevel = string;

export class WidgetBirthdays {
  @IsBoolean()
  @IsNotEmpty()
  employee_employees_same_unit: boolean;

  @IsBoolean()
  @IsNotEmpty()
  employee_manager: boolean;

  @IsBoolean()
  @IsNotEmpty()
  employee_managers_same_level_units: boolean;

  @IsBoolean()
  @IsNotEmpty()
  employee_managers: boolean;

  @IsIn(['first', 'all'])
  @IsString()
  @IsNotEmpty()
  employee_managers_level: 'first' | 'all';

  @IsBoolean()
  @IsNotEmpty()
  manager_employees_same_unit: boolean;

  @IsBoolean()
  @IsNotEmpty()
  manager_employees_same_level_units: boolean;

  @IsBoolean()
  @IsNotEmpty()
  manager_managers: boolean;

  @IsIn(['first', 'all'])
  @IsString()
  @IsNotEmpty()
  manager_managers_level: 'first' | 'all';
}

export class GetAccountWidgetBirthdaysResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @ValidateNested()
  @Type(() => WidgetBirthdays)
  @IsNotEmpty()
  scope_settings: WidgetBirthdays;
}

export type AccountPostsFeedCategoriesFilterOptionsResponse =
  FilterSelectOption[];

export type AccountPostsFeedCommunitiesFilterOptionsResponse =
  FilterSelectOption[];

export class GetAccountWidgetPostsFeedAvailableFiltersResponse {
  @IsArray()
  @IsNotEmpty()
  filters: (
    | FilterSelect
    | FilterMultiple
    | FilterText
    | FilterSearch
    | FilterMultipleSearch
    | FilterBool
  )[];
}

export type CryptoProPluginOpenType = string;

export class CompanyItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  tsp_url?: string;

  @IsIn(['capi', 'cades'])
  @IsString()
  @IsOptional()
  crypto_pro_plugin_open_type?: 'capi' | 'cades';

  @IsIn(['api', 'browser_plugin'])
  @IsString()
  @IsOptional()
  hash_source?: 'api' | 'browser_plugin';
}

export class SocialUserCompanyPosition {
  @ValidateNested()
  @Type(() => CompanyItem)
  @IsNotEmpty()
  company: CompanyItem;

  @IsString()
  @IsNotEmpty()
  position: string;

  @IsString()
  @IsOptional()
  unit_name?: string;
}

export class SocialUser {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  first_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  second_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  middle_name: string;

  @IsString()
  @IsOptional()
  logo?: string;

  @ValidateNested({ each: true })
  @Type(() => SocialUserCompanyPosition)
  @IsArray()
  @IsOptional()
  companies?: SocialUserCompanyPosition[];
}

export type CommunityType = string;

export class AccountItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class CommunityInfo {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;
}

export class PostData {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => CommunityInfo)
  @IsNotEmpty()
  community: CommunityInfo;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsOptional()
  summary?: string;

  @ValidateNested()
  @Type(() => SocialUser)
  @IsNotEmpty()
  author: SocialUser;

  @IsDateString()
  @IsNotEmpty()
  created_at: string;

  @IsDateString()
  @IsOptional()
  published_at?: string;

  @IsBoolean()
  @IsOptional()
  is_pinned?: boolean;
}

export class NewsAuthor {
  @IsUUID()
  @IsNotEmpty()
  user_id: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  first_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  second_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  middle_name: string;

  @IsString()
  @IsOptional()
  position?: string;
}

export class Category {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['gray', 'darkgray', 'green', 'orange', 'purple', 'blue', 'red'])
  @IsString()
  @IsNotEmpty()
  color: 'gray' | 'darkgray' | 'green' | 'orange' | 'purple' | 'blue' | 'red';
}

export class NewsData {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @ValidateNested({ each: true })
  @Type(() => CompanyItem)
  @IsArray()
  @IsOptional()
  companies?: CompanyItem[];

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsOptional()
  announcement?: string;

  @IsUUID()
  @IsNotEmpty()
  cover_att_id: string;

  @ValidateNested()
  @Type(() => Category)
  @IsOptional()
  category?: Category;

  @IsDateString()
  @IsNotEmpty()
  published_at: string;

  @IsBoolean()
  @IsNotEmpty()
  is_important: boolean;

  @IsBoolean()
  @IsOptional()
  is_pinned?: boolean;

  @ValidateNested()
  @Type(() => NewsAuthor)
  @IsNotEmpty()
  author: NewsAuthor;
}

export class PinnedItems {
  @IsUUID()
  @IsOptional()
  news_id?: string;

  @IsUUID()
  @IsOptional()
  post_id?: string;
}

export class GetAccountWidgetPostsFeedResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @ValidateNested()
  @Type(() => PinnedItems)
  @IsOptional()
  pinned_items?: PinnedItems;

  @IsArray()
  @IsOptional()
  items?: (NewsData | PostData)[];

  @IsInt()
  @IsOptional()
  total?: number;
}

export type ParentUnitsManagersOption = string;

export class WidgetAbsencesManagerSettings {
  @IsBoolean()
  @IsOptional()
  direct_subordinates?: boolean;

  @IsBoolean()
  @IsOptional()
  subunits_subordinates?: boolean;

  @IsBoolean()
  @IsOptional()
  other_units_managers_at_same_level_hierarchy?: boolean;

  @IsBoolean()
  @IsOptional()
  other_units_employees_at_same_level_hierarchy?: boolean;

  @IsBoolean()
  @IsOptional()
  parent_units_managers?: boolean;

  @IsIn(['one_level', 'all'])
  @IsString()
  @IsOptional()
  parent_units_managers_option?: 'one_level' | 'all';
}

export class WidgetAbsencesEmployeeSettings {
  @IsBoolean()
  @IsOptional()
  colleagues_from_same_unit?: boolean;

  @IsBoolean()
  @IsOptional()
  colleagues_from_subunits?: boolean;

  @IsBoolean()
  @IsOptional()
  direct_manager?: boolean;

  @IsBoolean()
  @IsOptional()
  other_units_managers_at_same_level_hierarchy?: boolean;

  @IsBoolean()
  @IsOptional()
  other_units_employees_at_same_level_hierarchy?: boolean;

  @IsBoolean()
  @IsOptional()
  parent_units_managers?: boolean;

  @IsIn(['one_level', 'all'])
  @IsString()
  @IsOptional()
  parent_units_managers_option?: 'one_level' | 'all';
}

export class AbsenceTypeGroupsSettings {
  @IsBoolean()
  @IsOptional()
  vacation?: boolean;

  @IsBoolean()
  @IsOptional()
  maternity_leave?: boolean;

  @IsBoolean()
  @IsOptional()
  student_leave?: boolean;
}

export class GetAccountWidgetAbsencesResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @ValidateNested()
  @Type(() => AbsenceTypeGroupsSettings)
  @IsOptional()
  absence_type_groups?: AbsenceTypeGroupsSettings;

  @ValidateNested()
  @Type(() => WidgetAbsencesEmployeeSettings)
  @IsOptional()
  employee_settings?: WidgetAbsencesEmployeeSettings;

  @ValidateNested()
  @Type(() => WidgetAbsencesManagerSettings)
  @IsOptional()
  manager_settings?: WidgetAbsencesManagerSettings;
}

export type WidgetPartitionType = string;

export class WidgetPartition {
  @IsIn([
    'events',
    'events_employee',
    'events_company',
    'candidates',
    'personal_profile',
    'policies',
    'absences',
    'vacation',
    'vacation_employee',
    'vacation_company',
    'competencies',
    'payslips',
    'events_to_paper',
    'employees',
    'organization',
    'review',
    'payroll',
    'training',
    'benefits',
    'statements',
    'businesstrip',
    'settings_event_types',
    'settings_templates',
    'settings_groups',
    'settings_substitutes',
    'settings_vacation',
    'settings_company',
    'settings_attorneys',
    'settings_attorneys_users',
    'settings_unep_types',
  ])
  @IsString()
  @IsNotEmpty()
  type:
    | 'events'
    | 'events_employee'
    | 'events_company'
    | 'candidates'
    | 'personal_profile'
    | 'policies'
    | 'absences'
    | 'vacation'
    | 'vacation_employee'
    | 'vacation_company'
    | 'competencies'
    | 'payslips'
    | 'events_to_paper'
    | 'employees'
    | 'organization'
    | 'review'
    | 'payroll'
    | 'training'
    | 'benefits'
    | 'statements'
    | 'businesstrip'
    | 'settings_event_types'
    | 'settings_templates'
    | 'settings_groups'
    | 'settings_substitutes'
    | 'settings_vacation'
    | 'settings_company'
    | 'settings_attorneys'
    | 'settings_attorneys_users'
    | 'settings_unep_types';

  @IsIn([1, 2, 3])
  @IsInt()
  @IsOptional()
  width?: 1 | 2 | 3;
}

export class WidgetPartitionGrid {
  @IsIn([1, 2, 3])
  @IsInt()
  @IsNotEmpty()
  cols: 1 | 2 | 3;

  @IsIn([1, 2, 3, 4, 5])
  @IsInt()
  @IsNotEmpty()
  rows: 1 | 2 | 3 | 4 | 5;
}

export class GetAccountWidgetPartitionsResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @ValidateNested()
  @Type(() => WidgetPartitionGrid)
  @IsOptional()
  grid?: WidgetPartitionGrid;

  @ValidateNested({ each: true })
  @Type(() => WidgetPartition)
  @IsArray()
  @IsNotEmpty()
  partitions: WidgetPartition[];
}

export class WidgetPartitionCreateOption {
  @IsIn([
    'events',
    'events_employee',
    'events_company',
    'candidates',
    'personal_profile',
    'policies',
    'absences',
    'vacation',
    'vacation_employee',
    'vacation_company',
    'competencies',
    'payslips',
    'events_to_paper',
    'employees',
    'organization',
    'review',
    'payroll',
    'training',
    'benefits',
    'statements',
    'businesstrip',
    'settings_event_types',
    'settings_templates',
    'settings_groups',
    'settings_substitutes',
    'settings_vacation',
    'settings_company',
    'settings_attorneys',
    'settings_attorneys_users',
    'settings_unep_types',
  ])
  @IsString()
  @IsNotEmpty()
  type:
    | 'events'
    | 'events_employee'
    | 'events_company'
    | 'candidates'
    | 'personal_profile'
    | 'policies'
    | 'absences'
    | 'vacation'
    | 'vacation_employee'
    | 'vacation_company'
    | 'competencies'
    | 'payslips'
    | 'events_to_paper'
    | 'employees'
    | 'organization'
    | 'review'
    | 'payroll'
    | 'training'
    | 'benefits'
    | 'statements'
    | 'businesstrip'
    | 'settings_event_types'
    | 'settings_templates'
    | 'settings_groups'
    | 'settings_substitutes'
    | 'settings_vacation'
    | 'settings_company'
    | 'settings_attorneys'
    | 'settings_attorneys_users'
    | 'settings_unep_types';
}

export class GetAccountWidgetCreateOptionsResponse {
  @IsIn([
    'quick_actions',
    'tasks',
    'links',
    'calendar',
    'partitions_employee',
    'partitions_company',
    'personal_links',
    'banner',
    'external',
    'news',
    'surveys',
    'absences',
    'top_news',
    'posts_feed',
    'birthdays',
  ])
  @IsString()
  @IsNotEmpty()
  widget_type:
    | 'quick_actions'
    | 'tasks'
    | 'links'
    | 'calendar'
    | 'partitions_employee'
    | 'partitions_company'
    | 'personal_links'
    | 'banner'
    | 'external'
    | 'news'
    | 'surveys'
    | 'absences'
    | 'top_news'
    | 'posts_feed'
    | 'birthdays';

  @IsIn(
    [
      'events',
      'events_employee',
      'events_company',
      'candidates',
      'personal_profile',
      'policies',
      'absences',
      'vacation',
      'vacation_employee',
      'vacation_company',
      'competencies',
      'payslips',
      'events_to_paper',
      'employees',
      'organization',
      'review',
      'payroll',
      'training',
      'benefits',
      'statements',
      'businesstrip',
      'settings_event_types',
      'settings_templates',
      'settings_groups',
      'settings_substitutes',
      'settings_vacation',
      'settings_company',
      'settings_attorneys',
      'settings_attorneys_users',
      'settings_unep_types',
    ],
    { each: true },
  )
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  requiredPartitions?: (
    | 'events'
    | 'events_employee'
    | 'events_company'
    | 'candidates'
    | 'personal_profile'
    | 'policies'
    | 'absences'
    | 'vacation'
    | 'vacation_employee'
    | 'vacation_company'
    | 'competencies'
    | 'payslips'
    | 'events_to_paper'
    | 'employees'
    | 'organization'
    | 'review'
    | 'payroll'
    | 'training'
    | 'benefits'
    | 'statements'
    | 'businesstrip'
    | 'settings_event_types'
    | 'settings_templates'
    | 'settings_groups'
    | 'settings_substitutes'
    | 'settings_vacation'
    | 'settings_company'
    | 'settings_attorneys'
    | 'settings_attorneys_users'
    | 'settings_unep_types'
  )[];

  @ValidateNested({ each: true })
  @Type(() => WidgetPartitionCreateOption)
  @IsArray()
  @IsNotEmpty()
  availablePartitions: WidgetPartitionCreateOption[];
}

export class SlideItemConstruct {
  @IsString()
  @IsOptional()
  title?: string;

  @IsString()
  @IsOptional()
  text?: string;

  @IsString()
  @IsOptional()
  caption?: string;

  @IsIn(['black', 'white'])
  @IsString()
  @IsOptional()
  text_color?: 'black' | 'white';

  @IsIn(['primary', 'secondary', 'link'])
  @IsString()
  @IsNotEmpty()
  button_type: 'primary' | 'secondary' | 'link';

  @IsString()
  @IsNotEmpty()
  button_text: string;

  @IsUUID()
  @IsOptional()
  background_image_id?: string;

  @IsUUID()
  @IsOptional()
  additional_image_id?: string;

  @IsString()
  @IsNotEmpty()
  url: string;
}

export class BannerConstruct {
  @IsIn(['construct'])
  @IsString()
  @IsNotEmpty()
  type: 'construct';

  @ValidateNested({ each: true })
  @Type(() => SlideItemConstruct)
  @IsArray()
  @IsNotEmpty()
  slides: SlideItemConstruct[];
}

export class SlideItemSimple {
  @IsUUID()
  @IsNotEmpty()
  background_image_id: string;

  @IsString()
  @IsNotEmpty()
  url: string;
}

export class BannerSimple {
  @IsIn(['simple'])
  @IsString()
  @IsNotEmpty()
  type: 'simple';

  @ValidateNested({ each: true })
  @Type(() => SlideItemSimple)
  @IsArray()
  @IsNotEmpty()
  slides: SlideItemSimple[];
}

export class GetAccountWidgetBannerResponse {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @IsNotEmpty()
  banner: BannerSimple | BannerConstruct;
}

export class GetAccountWidgetTopNewsResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @IsIn(['type_1_4', 'type_4'])
  @IsString()
  @IsNotEmpty()
  type: 'type_1_4' | 'type_4';

  @IsIn([1, 2, 3])
  @IsInt()
  @IsOptional()
  widget_size?: 1 | 2 | 3;

  @ValidateNested({ each: true })
  @Type(() => NewsData)
  @IsArray()
  @IsNotEmpty()
  news: NewsData[];
}

export class WidgetLink {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  link_id?: string;

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsOptional()
  logo_id?: string;

  @IsIn(['employee', 'company', 'group', 'manager'])
  @IsString()
  @IsNotEmpty()
  access_level: 'employee' | 'company' | 'group' | 'manager';

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  group?: string[];
}

export class GetAccountWidgetLinksResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @ValidateNested({ each: true })
  @Type(() => WidgetLink)
  @IsArray()
  @IsOptional()
  links?: WidgetLink[];
}

export type Side = string;

export class QuickActionCreateEvent {
  @IsIn(['employee', 'company'])
  @IsString()
  @IsNotEmpty()
  side: 'employee' | 'company';

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsIn(['create_event'])
  @IsString()
  @IsNotEmpty()
  type: 'create_event';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  event_type_ids?: string[];
}

export class GetAccountWidgetQuickActionsResponse {
  @IsUUID()
  @IsOptional()
  company_content_id?: string;

  @IsUUID()
  @IsOptional()
  source_widget_id?: string;

  @IsArray()
  @IsNotEmpty()
  actions: QuickActionCreateEvent[];

  @IsArray()
  @IsNotEmpty()
  available_actions: QuickActionCreateEvent[];
}

export class CreateWidgetBannerResponse {
  @IsUUID()
  @IsOptional()
  widget_id?: string;
}

export class Exception {
  @IsIn(['widget_layout', 'widget_content'])
  @IsString()
  @IsNotEmpty()
  name: 'widget_layout' | 'widget_content';

  @IsInt()
  @IsOptional()
  count?: number;
}

export class AccountWidgetExceptions {
  @ValidateNested()
  @Type(() => WidgetCompany)
  @IsNotEmpty()
  company: WidgetCompany;

  @ValidateNested({ each: true })
  @Type(() => Exception)
  @IsArray()
  @IsNotEmpty()
  exceptions: Exception[];
}

export class GetAccountWidgetsExceptionsResponse {
  @ValidateNested({ each: true })
  @Type(() => AccountWidgetExceptions)
  @IsArray()
  @IsNotEmpty()
  companies: AccountWidgetExceptions[];

  @IsInt()
  @IsNotEmpty()
  total_count: number;
}

export class GetAccountWidgetMainLayoutResponse {
  @IsBoolean()
  @IsNotEmpty()
  is_exception_from_account: boolean;

  @IsBoolean()
  @IsNotEmpty()
  has_account_widgets: boolean;

  @ValidateNested({ each: true })
  @Type(() => Widget)
  @IsArray()
  @IsNotEmpty()
  widgets: Widget[];
}

export class GetUserWidgetExternalResponse {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsInt()
  @IsNotEmpty()
  height: number;
}

export class AbsenceActiveNode {
  @IsIn(['upload', 'generate_document_from_template', 'sign', 'accept'], {
    each: true,
  })
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  actions?: (
    | 'upload'
    | 'generate_document_from_template'
    | 'sign'
    | 'accept'
  )[];

  @IsDateString()
  @IsOptional()
  deadline?: string;
}

export type AbsenceStatus = string;

export class AbsenceItem {
  @IsString()
  @IsNotEmpty()
  type: string;

  @IsString()
  @IsOptional()
  type_group?: string;

  @IsIn([
    'new',
    'event_created',
    'approved',
    'in_progress',
    'completed',
    'canceled',
  ])
  @IsString()
  @IsNotEmpty()
  status:
    | 'new'
    | 'event_created'
    | 'approved'
    | 'in_progress'
    | 'completed'
    | 'canceled';

  @IsDateString()
  @IsNotEmpty()
  from_date: string;

  @IsDateString()
  @IsNotEmpty()
  to_date: string;

  @IsInt()
  @IsNotEmpty()
  days_count: number;

  @ValidateNested({ each: true })
  @Type(() => AbsenceActiveNode)
  @IsArray()
  @IsOptional()
  active_nodes?: AbsenceActiveNode[];

  @IsBoolean()
  @IsNotEmpty()
  is_monetary_compensation: boolean;
}

export type DateType = string;

export class WorkCalendarDate {
  @IsDateString()
  @IsNotEmpty()
  date: string;

  @IsIn(['workday', 'weekend', 'holiday'])
  @IsString()
  @IsNotEmpty()
  type: 'workday' | 'weekend' | 'holiday';
}

export class CalendarWidgetEmployee {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  personnel_number: string;

  @IsString()
  @IsNotEmpty()
  position: string;

  @IsString()
  @IsOptional()
  unit_name?: string;

  @IsNumber()
  @IsNotEmpty()
  vacation_available_days: number;

  @ValidateNested({ each: true })
  @Type(() => WorkCalendarDate)
  @IsArray()
  @IsNotEmpty()
  calendar_diff: WorkCalendarDate[];

  @ValidateNested({ each: true })
  @Type(() => AbsenceItem)
  @IsArray()
  @IsNotEmpty()
  absences: AbsenceItem[];
}

export class CalendarWidgetCompany {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @ValidateNested({ each: true })
  @Type(() => CalendarWidgetEmployee)
  @IsArray()
  @IsNotEmpty()
  employees: CalendarWidgetEmployee[];
}

export class GetUserWidgetCalendarResponse {
  @ValidateNested({ each: true })
  @Type(() => CalendarWidgetCompany)
  @IsArray()
  @IsNotEmpty()
  companies: CalendarWidgetCompany[];
}

export class FeedPostUserActions {
  @IsBoolean()
  @IsOptional()
  favorites?: boolean;
}

export class Reaction {
  @IsString()
  @IsNotEmpty()
  type: string;
}

export class ReactionItem {
  @ValidateNested()
  @Type(() => Reaction)
  @IsNotEmpty()
  reaction: Reaction;

  @IsInt()
  @IsNotEmpty()
  count: number;
}

export class EntityReactions {
  @ValidateNested({ each: true })
  @Type(() => ReactionItem)
  @IsArray()
  @IsNotEmpty()
  data: ReactionItem[];

  @IsString()
  @IsOptional()
  active_reaction_type?: string;
}

export class ContentSurveyActions {
  @IsBoolean()
  @IsNotEmpty()
  results: boolean;

  @IsBoolean()
  @IsNotEmpty()
  report: boolean;
}

export class UserAnswerMultipleTextChoice {
  @IsIn(['multiple_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'multiple_text_choice';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  selected_options: string[];
}

export class UserAnswerSingleTextChoice {
  @IsIn(['single_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'single_text_choice';

  @IsUUID()
  @IsOptional()
  selected_option?: string;
}

export class UserAnswerFreeText {
  @IsIn(['free_text'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'free_text';

  @IsString()
  @IsNotEmpty()
  text: string;
}

export class ContentSurveyUserAnswerOneOf {
  @IsNotEmpty()
  object:
    | UserAnswerFreeText
    | UserAnswerSingleTextChoice
    | UserAnswerMultipleTextChoice;
}

export class ContentSurveyUserAnswer {
  @IsUUID()
  @IsNotEmpty()
  question_id: string;

  @ValidateNested()
  @Type(() => ContentSurveyUserAnswerOneOf)
  @IsOptional()
  user_answer?: ContentSurveyUserAnswerOneOf;
}

export class ContentSurveyUserPassing {
  @ValidateNested({ each: true })
  @Type(() => ContentSurveyUserAnswer)
  @IsArray()
  @IsNotEmpty()
  answers: ContentSurveyUserAnswer[];

  @IsInt()
  @IsNotEmpty()
  version: number;
}

export class FreeTextAnswerSettings {
  @IsIn(['free_text'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'free_text';

  @IsInt()
  @IsOptional()
  max_length?: number;

  @IsInt()
  @IsOptional()
  min_length?: number;
}

export class TextChoiceAnswerOption {
  @IsUUID()
  @IsOptional()
  id?: string;

  @IsIn(['text'])
  @IsString()
  @IsNotEmpty()
  type: 'text';

  @IsString()
  @IsNotEmpty()
  text_value: string;
}

export class MultipleTextChoiceAnswerSettings {
  @IsIn(['multiple_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'multiple_text_choice';

  @ValidateNested({ each: true })
  @Type(() => TextChoiceAnswerOption)
  @IsArray()
  @IsNotEmpty()
  answer_options: TextChoiceAnswerOption[];
}

export class SingleTextChoiceAnswerSettings {
  @IsIn(['single_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'single_text_choice';

  @ValidateNested({ each: true })
  @Type(() => TextChoiceAnswerOption)
  @IsArray()
  @IsNotEmpty()
  answer_options: TextChoiceAnswerOption[];
}

export class ContentSurveyQuestionAnswerSettings {
  @IsNotEmpty()
  object:
    | SingleTextChoiceAnswerSettings
    | MultipleTextChoiceAnswerSettings
    | FreeTextAnswerSettings;
}

export type AttachmentItemType = string;

export class AttachmentItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsIn(['image', 'file'])
  @IsString()
  @IsNotEmpty()
  type: 'image' | 'file';
}

export class BaseContentItem {
  @IsString()
  @IsOptional()
  data?: string;

  @ValidateNested({ each: true })
  @Type(() => AttachmentItem)
  @IsArray()
  @IsOptional()
  attachments?: AttachmentItem[];
}

export class ContentSurveyQuestion {
  @IsUUID()
  @IsOptional()
  id?: string;

  @ValidateNested()
  @Type(() => BaseContentItem)
  @IsNotEmpty()
  content: BaseContentItem;

  @ValidateNested()
  @Type(() => ContentSurveyQuestionAnswerSettings)
  @IsNotEmpty()
  answer_settings: ContentSurveyQuestionAnswerSettings;
}

export class ContentSurvey {
  @IsUUID()
  @IsOptional()
  id?: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsBoolean()
  @IsNotEmpty()
  anonymous: boolean;

  @IsBoolean()
  @IsNotEmpty()
  show_result: boolean;

  @IsDateString()
  @IsOptional()
  completed_at?: string;

  @IsInt()
  @IsNotEmpty()
  version: number;

  @ValidateNested({ each: true })
  @Type(() => ContentSurveyQuestion)
  @IsArray()
  @IsNotEmpty()
  questions: ContentSurveyQuestion[];
}

export class ContentSurveyItem {
  @ValidateNested()
  @Type(() => ContentSurvey)
  @IsNotEmpty()
  survey: ContentSurvey;

  @IsInt()
  @IsOptional()
  passes_num?: number;

  @ValidateNested()
  @Type(() => ContentSurveyUserPassing)
  @IsOptional()
  passing?: ContentSurveyUserPassing;

  @ValidateNested()
  @Type(() => ContentSurveyActions)
  @IsOptional()
  actions?: ContentSurveyActions;
}

export class MentionItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsIn(['user', 'unit'])
  @IsString()
  @IsNotEmpty()
  type: 'user' | 'unit';
}

export class ContentItem {
  @IsString()
  @IsOptional()
  data?: string;

  @ValidateNested({ each: true })
  @Type(() => AttachmentItem)
  @IsArray()
  @IsOptional()
  attachments?: AttachmentItem[];

  @ValidateNested({ each: true })
  @Type(() => MentionItem)
  @IsArray()
  @IsOptional()
  mentions?: MentionItem[];

  @ValidateNested({ each: true })
  @Type(() => ContentSurveyItem)
  @IsArray()
  @IsOptional()
  surveys?: ContentSurveyItem[];
}

export class FeedPostData {
  @IsIn(['post'])
  @IsString()
  @IsNotEmpty()
  type: 'post';

  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => CommunityInfo)
  @IsNotEmpty()
  community: CommunityInfo;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsUUID()
  @IsOptional()
  cover_attachment_id?: string;

  @IsIn(['summary', 'extended'])
  @IsString()
  @IsNotEmpty()
  content_type: 'summary' | 'extended';

  @IsString()
  @IsOptional()
  summary?: string;

  @ValidateNested()
  @Type(() => ContentItem)
  @IsOptional()
  content?: ContentItem;

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];

  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  author?: SocialUser;

  @IsDateString()
  @IsNotEmpty()
  created_at: string;

  @IsDateString()
  @IsOptional()
  published_at?: string;

  @IsIn(['owner', 'administrator'])
  @IsString()
  @IsOptional()
  edited_by?: 'owner' | 'administrator';

  @ValidateNested()
  @Type(() => EntityReactions)
  @IsOptional()
  reactions?: EntityReactions;

  @IsInt()
  @IsOptional()
  comments_num?: number;

  @IsInt()
  @IsOptional()
  views_num?: number;

  @IsBoolean()
  @IsOptional()
  is_pinned_in_feed?: boolean;

  @ValidateNested()
  @Type(() => FeedPostUserActions)
  @IsOptional()
  actions?: FeedPostUserActions;

  @IsBoolean()
  @IsOptional()
  in_favorites?: boolean;
}

export class FeedNewsUserActions {
  @IsBoolean()
  @IsOptional()
  favorites?: boolean;
}

export class NewsActivityInfo {
  @IsInt()
  @IsNotEmpty()
  views_num: number;

  @IsInt()
  @IsOptional()
  comments_num?: number;

  @IsInt()
  @IsOptional()
  reactions_num?: number;
}

export class PostsFeedNewsData {
  @IsIn(['news'])
  @IsString()
  @IsNotEmpty()
  type: 'news';

  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @IsDateString()
  @IsNotEmpty()
  published_at: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  announcement: string;

  @IsUUID()
  @IsNotEmpty()
  cover_att_id: string;

  @ValidateNested()
  @Type(() => Category)
  @IsNotEmpty()
  category: Category;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];

  @ValidateNested()
  @Type(() => ContentItem)
  @IsNotEmpty()
  content: ContentItem;

  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  author?: SocialUser;

  @ValidateNested()
  @Type(() => NewsActivityInfo)
  @IsNotEmpty()
  activity_info: NewsActivityInfo;

  @IsBoolean()
  @IsNotEmpty()
  is_important: boolean;

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;

  @ValidateNested()
  @Type(() => EntityReactions)
  @IsOptional()
  reactions?: EntityReactions;

  @IsBoolean()
  @IsOptional()
  is_pinned_in_feed?: boolean;

  @ValidateNested()
  @Type(() => FeedNewsUserActions)
  @IsOptional()
  actions?: FeedNewsUserActions;

  @IsBoolean()
  @IsOptional()
  in_favorites?: boolean;
}

export class GetUserWidgetPostsFeedResponse {
  @IsArray()
  @IsNotEmpty()
  feed: (PostsFeedNewsData | FeedPostData)[];

  @IsInt()
  @IsNotEmpty()
  total: number;
}

export class BirthdayEmployee {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  company_name: string;

  @IsString()
  @IsNotEmpty()
  personnel_number: string;

  @IsString()
  @IsNotEmpty()
  position: string;

  @IsString()
  @IsOptional()
  unit_name?: string;

  @IsDateString()
  @IsNotEmpty()
  birthday: string;

  @IsBoolean()
  @IsNotEmpty()
  personal_data_available: boolean;
}

export class GetUserWidgetBirthdaysResponse {
  @ValidateNested({ each: true })
  @Type(() => BirthdayEmployee)
  @IsArray()
  @IsNotEmpty()
  employees: BirthdayEmployee[];

  @IsInt()
  @IsNotEmpty()
  total: number;
}

export class WidgetTopNewsItemWidget {
  @IsIn(['type_1_4', 'type_4'])
  @IsString()
  @IsOptional()
  type?: 'type_1_4' | 'type_4';

  @ValidateNested({ each: true })
  @Type(() => NewsData)
  @IsArray()
  @IsOptional()
  news?: NewsData[];
}

export class WidgetTopNewsItem {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsString()
  @IsOptional()
  company_name?: string;

  @IsUUID()
  @IsOptional()
  account_id?: string;

  @IsString()
  @IsOptional()
  account_name?: string;

  @ValidateNested()
  @Type(() => WidgetTopNewsItemWidget)
  @IsNotEmpty()
  widget: WidgetTopNewsItemWidget;
}

export class GetUserWidgetTopNewsResponse {
  @ValidateNested({ each: true })
  @Type(() => WidgetTopNewsItem)
  @IsArray()
  @IsNotEmpty()
  top_news: WidgetTopNewsItem[];
}

export type AbsenceTypeGroupNick = string;

export class AbsenceEmployeeItem {
  @IsUUID()
  @IsOptional()
  user_id?: string;

  @IsString()
  @IsOptional()
  fio?: string;

  @IsString()
  @IsOptional()
  position?: string;

  @IsString()
  @IsOptional()
  full_position?: string;

  @IsIn(['vacation', 'maternity_leave', 'student_leave'])
  @IsString()
  @IsOptional()
  absence_type_group?: 'vacation' | 'maternity_leave' | 'student_leave';

  @IsDateString()
  @IsOptional()
  from_date?: string;

  @IsDateString()
  @IsOptional()
  to_date?: string;

  @IsBoolean()
  @IsOptional()
  role_model_enabled?: boolean;

  @IsBoolean()
  @IsOptional()
  is_monetary_compensation?: boolean;
}

export class GetUserWidgetAbsencesResponse {
  @IsBoolean()
  @IsOptional()
  is_manager?: boolean;

  @ValidateNested({ each: true })
  @Type(() => AbsenceEmployeeItem)
  @IsArray()
  @IsOptional()
  absences?: AbsenceEmployeeItem[];
}

export class GetUserWidgetBannerResponse {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsNotEmpty()
  banner: BannerSimple | BannerConstruct;
}

export class WidgetPartitionView {
  @IsIn([
    'events',
    'events_employee',
    'events_company',
    'candidates',
    'personal_profile',
    'policies',
    'absences',
    'vacation',
    'vacation_employee',
    'vacation_company',
    'competencies',
    'payslips',
    'events_to_paper',
    'employees',
    'organization',
    'review',
    'payroll',
    'training',
    'benefits',
    'statements',
    'businesstrip',
    'settings_event_types',
    'settings_templates',
    'settings_groups',
    'settings_substitutes',
    'settings_vacation',
    'settings_company',
    'settings_attorneys',
    'settings_attorneys_users',
    'settings_unep_types',
  ])
  @IsString()
  @IsNotEmpty()
  type:
    | 'events'
    | 'events_employee'
    | 'events_company'
    | 'candidates'
    | 'personal_profile'
    | 'policies'
    | 'absences'
    | 'vacation'
    | 'vacation_employee'
    | 'vacation_company'
    | 'competencies'
    | 'payslips'
    | 'events_to_paper'
    | 'employees'
    | 'organization'
    | 'review'
    | 'payroll'
    | 'training'
    | 'benefits'
    | 'statements'
    | 'businesstrip'
    | 'settings_event_types'
    | 'settings_templates'
    | 'settings_groups'
    | 'settings_substitutes'
    | 'settings_vacation'
    | 'settings_company'
    | 'settings_attorneys'
    | 'settings_attorneys_users'
    | 'settings_unep_types';

  @IsIn([1, 2, 3])
  @IsInt()
  @IsOptional()
  width?: 1 | 2 | 3;

  @IsInt()
  @IsOptional()
  count_my?: number;

  @IsInt()
  @IsOptional()
  count_all?: number;

  @IsInt()
  @IsOptional()
  count_urgent?: number;

  @IsBoolean({ each: true })
  @IsArray()
  @IsOptional()
  links_visibility?: boolean[];
}

export class GetUserWidgetPartitionsResponse {
  @ValidateNested()
  @Type(() => WidgetPartitionGrid)
  @IsOptional()
  grid?: WidgetPartitionGrid;

  @ValidateNested({ each: true })
  @Type(() => WidgetPartitionView)
  @IsArray()
  @IsNotEmpty()
  partitions: WidgetPartitionView[];
}

export class GetUserWidgetSurveysResponse {
  @IsString()
  @IsNotEmpty()
  custom_name: string;
}

export class GetUserWidgetNewsResponse {
  @IsString()
  @IsOptional()
  custom_name?: string;

  @IsBoolean()
  @IsOptional()
  has_filter?: boolean;

  @IsBoolean()
  @IsNotEmpty()
  company_has_filter: boolean;
}

export class PersonalLink {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  icon: string;
}

export class GetUserWidgetPersonalLinksResponse {
  @IsString()
  @IsOptional()
  custom_name?: string;

  @ValidateNested({ each: true })
  @Type(() => PersonalLink)
  @IsArray()
  @IsOptional()
  personal_links?: PersonalLink[];
}

export class Link {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  url: string;
}

export class GetUserWidgetLinksResponse {
  @ValidateNested({ each: true })
  @Type(() => Link)
  @IsArray()
  @IsNotEmpty()
  links: Link[];
}

export class QuickActionLink {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  url: string;
}

export class GetUserWidgetQuickActionsResponse {
  @IsArray()
  @IsOptional()
  actions?: QuickActionCreateEvent[];

  @ValidateNested({ each: true })
  @Type(() => QuickActionLink)
  @IsArray()
  @IsOptional()
  links?: QuickActionLink[];
}

export class UserMainLayout {
  @ValidateNested({ each: true })
  @Type(() => Widget)
  @IsArray()
  @IsNotEmpty()
  widgets: Widget[];
}

export class WidgetListRequest {
  @IsIn(['account', 'company'])
  @IsString()
  @IsNotEmpty()
  bind_type: 'account' | 'company';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  account_ids?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];

  @IsIn([
    'quick_actions',
    'tasks',
    'links',
    'calendar',
    'partitions_employee',
    'partitions_company',
    'personal_links',
    'banner',
    'external',
    'news',
    'surveys',
    'absences',
    'top_news',
    'posts_feed',
    'birthdays',
  ])
  @IsString()
  @IsOptional()
  widget_type?:
    | 'quick_actions'
    | 'tasks'
    | 'links'
    | 'calendar'
    | 'partitions_employee'
    | 'partitions_company'
    | 'personal_links'
    | 'banner'
    | 'external'
    | 'news'
    | 'surveys'
    | 'absences'
    | 'top_news'
    | 'posts_feed'
    | 'birthdays';

  @IsIn(['active', 'inactive'])
  @IsString()
  @IsOptional()
  status?: 'active' | 'inactive';

  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class WidgetAccessTokenRequest {
  @IsString()
  @IsNotEmpty()
  client_id: string;

  @IsUUID()
  @IsNotEmpty()
  widget_id: string;
}

export class GetWidgetNewsRequestFilters {
  @IsString()
  @IsOptional()
  actor?: string;
}

export class GetWidgetNewsRequest {
  @ValidateNested()
  @Type(() => GetWidgetNewsRequestFilters)
  @IsOptional()
  filters?: GetWidgetNewsRequestFilters;
}

export class UpdateWidgetBirthdaysRequest {
  @ValidateNested()
  @Type(() => WidgetBirthdays)
  @IsNotEmpty()
  scope_settings: WidgetBirthdays;
}

export class UpdateWidgetAbsencesRequest {
  @ValidateNested()
  @Type(() => AbsenceTypeGroupsSettings)
  @IsOptional()
  absence_type_groups?: AbsenceTypeGroupsSettings;

  @ValidateNested()
  @Type(() => WidgetAbsencesEmployeeSettings)
  @IsOptional()
  employee_settings?: WidgetAbsencesEmployeeSettings;

  @ValidateNested()
  @Type(() => WidgetAbsencesManagerSettings)
  @IsOptional()
  manager_settings?: WidgetAbsencesManagerSettings;
}

export class UpdateWidgetPartitionsRequest {
  @ValidateNested()
  @Type(() => WidgetPartitionGrid)
  @IsOptional()
  grid?: WidgetPartitionGrid;

  @ValidateNested({ each: true })
  @Type(() => WidgetPartition)
  @IsArray()
  @IsNotEmpty()
  partitions: WidgetPartition[];
}

export class CreateWidgetBannerRequest {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsNotEmpty()
  banner: BannerSimple | BannerConstruct;
}

export class UpdateWidgetTopNewsRequest {
  @IsIn(['type_1_4', 'type_4'])
  @IsString()
  @IsNotEmpty()
  type: 'type_1_4' | 'type_4';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  news_ids: string[];
}

export class UpdateAccountWidgetLinksRequest {
  @ValidateNested({ each: true })
  @Type(() => WidgetLink)
  @IsArray()
  @IsNotEmpty()
  links: WidgetLink[];
}

export class UpdateAccountWidgetQuickActionsRequest {
  @IsArray()
  @IsNotEmpty()
  actions: QuickActionCreateEvent[];
}

export class EditableWidgetSettings {
  @IsBoolean()
  @IsOptional()
  user_editable?: boolean;

  @IsBoolean()
  @IsNotEmpty()
  user_switchable: boolean;

  @IsBoolean()
  @IsOptional()
  has_filter?: boolean;
}

export class EditableWidget {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => WidgetPosition)
  @IsNotEmpty()
  position: WidgetPosition;

  @IsIn([1, 2, 3])
  @IsInt()
  @IsNotEmpty()
  size: 1 | 2 | 3;

  @ValidateNested()
  @Type(() => EditableWidgetSettings)
  @IsOptional()
  settings?: EditableWidgetSettings;
}

export class UpdateAccountWidgetMainLayoutRequest {
  @ValidateNested({ each: true })
  @Type(() => EditableWidget)
  @IsArray()
  @IsNotEmpty()
  widgets: EditableWidget[];
}

export class UpdateUserWidgetActiveStateRequest {
  @IsBoolean()
  @IsNotEmpty()
  is_active: boolean;
}

export class UpdateUserWidgetSurveysRequest {
  @IsString()
  @IsNotEmpty()
  custom_name: string;
}

export class UpdateUserWidgetNewsRequest {
  @IsString()
  @IsOptional()
  custom_name?: string;

  @IsBoolean()
  @IsNotEmpty()
  has_filter: boolean;
}

export class PersonalLinkData {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  icon: string;
}

export class UpdateUserWidgetPersonalLinksRequest {
  @IsString()
  @IsOptional()
  custom_name?: string;

  @ValidateNested({ each: true })
  @Type(() => PersonalLinkData)
  @IsArray()
  @IsNotEmpty()
  personal_links: PersonalLinkData[];
}

export class UpdateUserWidgetQuickActionsRequest {
  @ValidateNested({ each: true })
  @Type(() => QuickActionLink)
  @IsArray()
  @IsNotEmpty()
  links: QuickActionLink[];
}

@injectable()
export class DashboardService {
  constructor(
    private validator: ValidationService,
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
    private query: QueryService,
  ) {}

  async getWidgetListAvailableFilters({
    query,
  }: {
    query: GetWidgetListAvailableFiltersQuery;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetWidgetListAvailableFiltersQuery,
      ),
    ]);

    let requestPath = '/widget/social/list/available_filters';

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async getSocialWidgetList({ body }: { body: WidgetListRequest }) {
    await Promise.all([
      this.validator.validateOrReject(body, WidgetListRequest),
    ]);

    let requestPath = '/widget/social/list';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetSocialWidgetListResponse,
    );

    return response;
  }

  async resetWidgetContent({ params }: { params: ResetWidgetContentParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, ResetWidgetContentParams),
    ]);

    let requestPath = '/widget/{widget_id}/reset_content';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof ResetWidgetContentParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async getWidgetAccessToken({ body }: { body: WidgetAccessTokenRequest }) {
    await Promise.all([
      this.validator.validateOrReject(body, WidgetAccessTokenRequest),
    ]);

    let requestPath = '/widget/access_token';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      WidgetAccessTokenResponse,
    );

    return response;
  }

  async refreshWidgetAccessToken({ body }: { body: WidgetAccessTokenRequest }) {
    await Promise.all([
      this.validator.validateOrReject(body, WidgetAccessTokenRequest),
    ]);

    let requestPath = '/widget/access_token/refresh';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      WidgetAccessTokenResponse,
    );

    return response;
  }

  async widgetLinkLogo({ params }: { params: WidgetLinkLogoParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, WidgetLinkLogoParams),
    ]);

    let requestPath = '/widget/link/{link_id}/logo';

    const paramsKeys = Object.keys(params) as (keyof WidgetLinkLogoParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.getFile(requestPath, {
      withAuth: true,
      withSide: false,
      isJson: true,
    });

    return result;
  }

  async getWidgetBannerImageFile({
    params,
  }: {
    params: GetWidgetBannerImageFileParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetWidgetBannerImageFileParams),
    ]);

    let requestPath = '/widget/banner/{widget_id}/{image_file_id}';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetWidgetBannerImageFileParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.getFile(requestPath, {
      withAuth: true,
      withSide: false,
      isJson: true,
    });

    return result;
  }

  async getWidgetSurveys({
    query = {},
  }: {
    query?: GetWidgetSurveysQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetWidgetSurveysQuery),
    ]);

    let requestPath = '/widget/surveys';

    const result = await this.http.get(requestPath, query, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetWidgetSurveysResponse,
    );

    return response;
  }

  async getWidgetNews({
    body = {},
  }: {
    body?: GetWidgetNewsRequest;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(body, GetWidgetNewsRequest),
    ]);

    let requestPath = '/widget/news';

    const result = await this.http.post(requestPath, body, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetWidgetNewsResponse,
    );

    return response;
  }

  async deleteCompanyWidgetsExceptionsFromAccount({
    params,
  }: {
    params: DeleteCompanyWidgetsExceptionsFromAccountParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        DeleteCompanyWidgetsExceptionsFromAccountParams,
      ),
    ]);

    let requestPath = '/company/{company_id}/widget/exceptions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof DeleteCompanyWidgetsExceptionsFromAccountParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async getAccountWidget({ params }: { params: GetAccountWidgetParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetAccountWidgetParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}';

    const paramsKeys = Object.keys(params) as (keyof GetAccountWidgetParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(result, Widget);

    return response;
  }

  async updateWidgetBirthdays({
    query = {},
    params,
    body,
  }: {
    query?: UpdateWidgetBirthdaysQuery;
    params: UpdateWidgetBirthdaysParams;
    body: UpdateWidgetBirthdaysRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateWidgetBirthdaysQuery),
      this.validator.validateOrReject(params, UpdateWidgetBirthdaysParams),
      this.validator.validateOrReject(body, UpdateWidgetBirthdaysRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/birthdays';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateWidgetBirthdaysParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetBirthdays({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetBirthdaysQuery;
    params: GetAccountWidgetBirthdaysParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetBirthdaysQuery),
      this.validator.validateOrReject(params, GetAccountWidgetBirthdaysParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/birthdays';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetBirthdaysParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetBirthdaysResponse,
    );

    return response;
  }

  async getAccountWidgetPostsFeedCategoriesFilterOption({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetPostsFeedCategoriesFilterOptionQuery;
    params: GetAccountWidgetPostsFeedCategoriesFilterOptionParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetAccountWidgetPostsFeedCategoriesFilterOptionQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetAccountWidgetPostsFeedCategoriesFilterOptionParams,
      ),
    ]);

    let requestPath =
      '/account/{account_id}/widget/{widget_id}/posts_feed/categories/filter_options';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetPostsFeedCategoriesFilterOptionParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getWidgetPostsFeedCommunitiesFilterOptions({
    query = {},
    params,
  }: {
    query?: GetWidgetPostsFeedCommunitiesFilterOptionsQuery;
    params: GetWidgetPostsFeedCommunitiesFilterOptionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetWidgetPostsFeedCommunitiesFilterOptionsQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetWidgetPostsFeedCommunitiesFilterOptionsParams,
      ),
    ]);

    let requestPath =
      '/account/{account_id}/widget/{widget_id}/posts_feed/communities/filter_options';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetWidgetPostsFeedCommunitiesFilterOptionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getAccountWidgetPostsFeedAvailableFilters({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetPostsFeedAvailableFiltersQuery;
    params: GetAccountWidgetPostsFeedAvailableFiltersParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetAccountWidgetPostsFeedAvailableFiltersQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetAccountWidgetPostsFeedAvailableFiltersParams,
      ),
    ]);

    let requestPath =
      '/account/{account_id}/widget/{widget_id}/posts_feed/available_filters';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetPostsFeedAvailableFiltersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async updateAccountWidgetPostsFeed({
    query = {},
    params,
    body = {},
  }: {
    query?: UpdateAccountWidgetPostsFeedQuery;
    params: UpdateAccountWidgetPostsFeedParams;
    body?: PinnedItems;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateAccountWidgetPostsFeedQuery),
      this.validator.validateOrReject(
        params,
        UpdateAccountWidgetPostsFeedParams,
      ),
      this.validator.validateOrReject(body, PinnedItems),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/posts_feed';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateAccountWidgetPostsFeedParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetPostsFeed({
    query,
    params,
  }: {
    query: GetAccountWidgetPostsFeedQuery;
    params: GetAccountWidgetPostsFeedParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetPostsFeedQuery),
      this.validator.validateOrReject(params, GetAccountWidgetPostsFeedParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/posts_feed';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetPostsFeedParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetPostsFeedResponse,
    );

    return response;
  }

  async updateWidgetAbsences({
    query = {},
    params,
    body = {},
  }: {
    query?: UpdateWidgetAbsencesQuery;
    params: UpdateWidgetAbsencesParams;
    body?: UpdateWidgetAbsencesRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateWidgetAbsencesQuery),
      this.validator.validateOrReject(params, UpdateWidgetAbsencesParams),
      this.validator.validateOrReject(body, UpdateWidgetAbsencesRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/absences';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateWidgetAbsencesParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetAbsences({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetAbsencesQuery;
    params: GetAccountWidgetAbsencesParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetAbsencesQuery),
      this.validator.validateOrReject(params, GetAccountWidgetAbsencesParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/absences';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetAbsencesParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetAbsencesResponse,
    );

    return response;
  }

  async getAccountWidgetPartitions({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetPartitionsQuery;
    params: GetAccountWidgetPartitionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetPartitionsQuery),
      this.validator.validateOrReject(params, GetAccountWidgetPartitionsParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/partitions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetPartitionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetPartitionsResponse,
    );

    return response;
  }

  async updateWidgetPartitions({
    query = {},
    params,
    body,
  }: {
    query?: UpdateWidgetPartitionsQuery;
    params: UpdateWidgetPartitionsParams;
    body: UpdateWidgetPartitionsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateWidgetPartitionsQuery),
      this.validator.validateOrReject(params, UpdateWidgetPartitionsParams),
      this.validator.validateOrReject(body, UpdateWidgetPartitionsRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/partitions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateWidgetPartitionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetCreateOptions({
    params,
  }: {
    params: GetAccountWidgetCreateOptionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        GetAccountWidgetCreateOptionsParams,
      ),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/create_options';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetCreateOptionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetCreateOptionsResponse,
    );

    return response;
  }

  async deleteWidgetBanner({
    query = {},
    params,
  }: {
    query?: DeleteWidgetBannerQuery;
    params: DeleteWidgetBannerParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, DeleteWidgetBannerQuery),
      this.validator.validateOrReject(params, DeleteWidgetBannerParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/banner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof DeleteWidgetBannerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async updateWidgetBanner({
    query = {},
    params,
    body,
  }: {
    query?: UpdateWidgetBannerQuery;
    params: UpdateWidgetBannerParams;
    body: CreateWidgetBannerRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateWidgetBannerQuery),
      this.validator.validateOrReject(params, UpdateWidgetBannerParams),
      this.validator.validateOrReject(body, CreateWidgetBannerRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/banner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateWidgetBannerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetBanner({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetBannerQuery;
    params: GetAccountWidgetBannerParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetBannerQuery),
      this.validator.validateOrReject(params, GetAccountWidgetBannerParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/banner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetBannerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetBannerResponse,
    );

    return response;
  }

  async updateWidgetTopNews({
    query = {},
    params,
    body,
  }: {
    query?: UpdateWidgetTopNewsQuery;
    params: UpdateWidgetTopNewsParams;
    body: UpdateWidgetTopNewsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateWidgetTopNewsQuery),
      this.validator.validateOrReject(params, UpdateWidgetTopNewsParams),
      this.validator.validateOrReject(body, UpdateWidgetTopNewsRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/top_news';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateWidgetTopNewsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetTopNews({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetTopNewsQuery;
    params: GetAccountWidgetTopNewsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetTopNewsQuery),
      this.validator.validateOrReject(params, GetAccountWidgetTopNewsParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/top_news';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetTopNewsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetTopNewsResponse,
    );

    return response;
  }

  async updateAccountWidgetLinks({
    query = {},
    params,
    body,
  }: {
    query?: UpdateAccountWidgetLinksQuery;
    params: UpdateAccountWidgetLinksParams;
    body: UpdateAccountWidgetLinksRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, UpdateAccountWidgetLinksQuery),
      this.validator.validateOrReject(params, UpdateAccountWidgetLinksParams),
      this.validator.validateOrReject(body, UpdateAccountWidgetLinksRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/links';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateAccountWidgetLinksParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetLinks({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetLinksQuery;
    params: GetAccountWidgetLinksParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetLinksQuery),
      this.validator.validateOrReject(params, GetAccountWidgetLinksParams),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/links';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetLinksParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetLinksResponse,
    );

    return response;
  }

  async updateAccountWidgetQuickActions({
    query = {},
    params,
    body,
  }: {
    query?: UpdateAccountWidgetQuickActionsQuery;
    params: UpdateAccountWidgetQuickActionsParams;
    body: UpdateAccountWidgetQuickActionsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        UpdateAccountWidgetQuickActionsQuery,
      ),
      this.validator.validateOrReject(
        params,
        UpdateAccountWidgetQuickActionsParams,
      ),
      this.validator.validateOrReject(
        body,
        UpdateAccountWidgetQuickActionsRequest,
      ),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/quick_actions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateAccountWidgetQuickActionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetQuickActions({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetQuickActionsQuery;
    params: GetAccountWidgetQuickActionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetQuickActionsQuery),
      this.validator.validateOrReject(
        params,
        GetAccountWidgetQuickActionsParams,
      ),
    ]);

    let requestPath = '/account/{account_id}/widget/{widget_id}/quick_actions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetQuickActionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetQuickActionsResponse,
    );

    return response;
  }

  async createWidgetBanner({
    query = {},
    params,
    body,
  }: {
    query?: CreateWidgetBannerQuery;
    params: CreateWidgetBannerParams;
    body: CreateWidgetBannerRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, CreateWidgetBannerQuery),
      this.validator.validateOrReject(params, CreateWidgetBannerParams),
      this.validator.validateOrReject(body, CreateWidgetBannerRequest),
    ]);

    let requestPath = '/account/{account_id}/widget/banner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof CreateWidgetBannerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CreateWidgetBannerResponse,
    );

    return response;
  }

  async getAccountWidgetsExceptions({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetsExceptionsQuery;
    params: GetAccountWidgetsExceptionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetsExceptionsQuery),
      this.validator.validateOrReject(
        params,
        GetAccountWidgetsExceptionsParams,
      ),
    ]);

    let requestPath = '/account/{account_id}/widget/exceptions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetsExceptionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetsExceptionsResponse,
    );

    return response;
  }

  async updateAccountWidgetMainLayout({
    query = {},
    params,
    body,
  }: {
    query?: UpdateAccountWidgetMainLayoutQuery;
    params: UpdateAccountWidgetMainLayoutParams;
    body: UpdateAccountWidgetMainLayoutRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        UpdateAccountWidgetMainLayoutQuery,
      ),
      this.validator.validateOrReject(
        params,
        UpdateAccountWidgetMainLayoutParams,
      ),
      this.validator.validateOrReject(
        body,
        UpdateAccountWidgetMainLayoutRequest,
      ),
    ]);

    let requestPath = '/account/{account_id}/widget/main_layout';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateAccountWidgetMainLayoutParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    requestPath = `${requestPath}${
      query && Object.keys(query).length
        ? `?${this.query.stringify(query)}`
        : ''
    }`;
    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getAccountWidgetMainLayout({
    query = {},
    params,
  }: {
    query?: GetAccountWidgetMainLayoutQuery;
    params: GetAccountWidgetMainLayoutParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountWidgetMainLayoutQuery),
      this.validator.validateOrReject(params, GetAccountWidgetMainLayoutParams),
    ]);

    let requestPath = '/account/{account_id}/widget/main_layout';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountWidgetMainLayoutParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetAccountWidgetMainLayoutResponse,
    );

    return response;
  }

  async getUserWidgetExternal({
    params,
  }: {
    params: GetUserWidgetExternalParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetExternalParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/external';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetExternalParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetExternalResponse,
    );

    return response;
  }

  async getUserWidgetCalendar({
    params,
  }: {
    params: GetUserWidgetCalendarParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetCalendarParams),
    ]);

    let requestPath = '/user/widget/calendar/{year}';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetCalendarParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetCalendarResponse,
    );

    return response;
  }

  async getUserWidgetPostsFeed({
    query = {},
    params,
  }: {
    query?: GetUserWidgetPostsFeedQuery;
    params: GetUserWidgetPostsFeedParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetUserWidgetPostsFeedQuery),
      this.validator.validateOrReject(params, GetUserWidgetPostsFeedParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/posts_feed';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetPostsFeedParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetPostsFeedResponse,
    );

    return response;
  }

  async getUserWidgetBirthdays({
    params,
  }: {
    params: GetUserWidgetBirthdaysParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetBirthdaysParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/birthdays';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetBirthdaysParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetBirthdaysResponse,
    );

    return response;
  }

  async getUserWidgetTopNews({
    params,
  }: {
    params: GetUserWidgetTopNewsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetTopNewsParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/top_news';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetTopNewsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetTopNewsResponse,
    );

    return response;
  }

  async getUserWidgetAbsences() {
    let requestPath = '/user/widget/absences';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetAbsencesResponse,
    );

    return response;
  }

  async getUserWidgetBanner({ params }: { params: GetUserWidgetBannerParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetBannerParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/banner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetBannerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetBannerResponse,
    );

    return response;
  }

  async getUserWidgetPartitions({
    params,
  }: {
    params: GetUserWidgetPartitionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetPartitionsParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/partitions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetPartitionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetPartitionsResponse,
    );

    return response;
  }

  async updateUserWidgetActiveState({
    params,
    body,
  }: {
    params: UpdateUserWidgetActiveStateParams;
    body: UpdateUserWidgetActiveStateRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        UpdateUserWidgetActiveStateParams,
      ),
      this.validator.validateOrReject(body, UpdateUserWidgetActiveStateRequest),
    ]);

    let requestPath = '/user/widget/{widget_id}/active_state';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateUserWidgetActiveStateParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getUserWidgetSurveys({
    params,
  }: {
    params: GetUserWidgetSurveysParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetSurveysParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/surveys';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetSurveysParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetSurveysResponse,
    );

    return response;
  }

  async updateUserWidgetSurveys({
    body,
  }: {
    body: UpdateUserWidgetSurveysRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(body, UpdateUserWidgetSurveysRequest),
    ]);

    let requestPath = '/user/widget/surveys';

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getUserWidgetNews({ params }: { params: GetUserWidgetNewsParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetNewsParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/news';

    const paramsKeys = Object.keys(params) as (keyof GetUserWidgetNewsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetNewsResponse,
    );

    return response;
  }

  async updateUserWidgetNews({ body }: { body: UpdateUserWidgetNewsRequest }) {
    await Promise.all([
      this.validator.validateOrReject(body, UpdateUserWidgetNewsRequest),
    ]);

    let requestPath = '/user/widget/news';

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async updateUserWidgetPersonalLinks({
    body,
  }: {
    body: UpdateUserWidgetPersonalLinksRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        body,
        UpdateUserWidgetPersonalLinksRequest,
      ),
    ]);

    let requestPath = '/user/widget/personal_links';

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getUserWidgetPersonalLinks({
    params,
  }: {
    params: GetUserWidgetPersonalLinksParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetUserWidgetPersonalLinksParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/personal_links';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetPersonalLinksParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetPersonalLinksResponse,
    );

    return response;
  }

  async getUserWidgetLinks() {
    let requestPath = '/user/widget/links';

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetLinksResponse,
    );

    return response;
  }

  async updateUserWidgetQuickActions({
    body,
  }: {
    body: UpdateUserWidgetQuickActionsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        body,
        UpdateUserWidgetQuickActionsRequest,
      ),
    ]);

    let requestPath = '/user/widget/quick_actions';

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async getUserWidgetQuickActions({
    query = {},
    params,
  }: {
    query?: GetUserWidgetQuickActionsQuery;
    params: GetUserWidgetQuickActionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetUserWidgetQuickActionsQuery),
      this.validator.validateOrReject(params, GetUserWidgetQuickActionsParams),
    ]);

    let requestPath = '/user/widget/{widget_id}/quick_actions';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetUserWidgetQuickActionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {
      reloadIfOldVersion: true,
    });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetUserWidgetQuickActionsResponse,
    );

    return response;
  }

  async getUserWidgetMainLayoutSettings() {
    let requestPath = '/user/widget/main_layout/settings';

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(result, UserMainLayout);

    return response;
  }

  async getUserWidgetMainLayout() {
    let requestPath = '/user/widget/main_layout';

    const result = await this.http.get(
      requestPath,
      {},
      { reloadIfOldVersion: true },
    );

    const response = await this.unmarshaller.unmarshall(result, UserMainLayout);

    return response;
  }
}
